import { graphql } from 'react-apollo';

import { branch } from 'recompose';

import type { ProgramScope } from 'bundles/enterprise-admin-users/contextUtils';
import { ProgramsAndRostersByOrganization, ProgramsAndRostersByPrograms } from 'bundles/enterprise-admin-users/queries';
import type { Program } from 'bundles/enterprise-admin-users/types';

import type {
  ProgramsAndRostersByOrganizationQuery,
  ProgramsAndRostersByOrganizationQueryVariables,
} from './__generated__/ProgramsAndRostersByOrganizationQuery';
import type {
  ProgramsAndRostersByProgramsQuery,
  ProgramsAndRostersByProgramsQueryVariables,
} from './__generated__/ProgramsAndRostersByProgramsQuery';

export type PropsForProgramsAndRostersByOrganization = {
  thirdPartyOrganizationId?: string;
};

type PropsForProgramsAndRostersByPrograms = ProgramScope;

export type PropsFromProgramsAndRosters = {
  programs?: (Program | null)[];
  loading?: boolean;
};

const withProgramsAndRostersByOrganization = graphql<
  PropsForProgramsAndRostersByOrganization,
  ProgramsAndRostersByOrganizationQuery,
  ProgramsAndRostersByOrganizationQueryVariables,
  PropsFromProgramsAndRosters
>(ProgramsAndRostersByOrganization, {
  options: (props) => ({
    variables: { thirdPartyOrganizationId: String(props.thirdPartyOrganizationId) },
  }),
  skip: (props) => !props.thirdPartyOrganizationId,
  props: ({ data }) => {
    let programs;
    let loading;
    if (data) {
      ({ loading } = data);
      programs = data.EnterpriseProgramsV1Resource?.byThirdPartyOrganizationId?.elements ?? [];
    }
    return { programs, loading };
  },
});

const withProgramsAndRostersByPrograms = graphql<
  PropsForProgramsAndRostersByPrograms,
  ProgramsAndRostersByProgramsQuery,
  ProgramsAndRostersByProgramsQueryVariables,
  PropsFromProgramsAndRosters
>(ProgramsAndRostersByPrograms, {
  options: (props) => ({
    variables: { programIds: props.programScope.programIds },
  }),
  props: ({ data }) => {
    let programs;
    let loading;
    if (data) {
      ({ loading } = data);
      programs = data.EnterpriseProgramsV1Resource?.multiGet?.elements ?? [];
    }
    return { programs, loading };
  },
});

export const withProgramsAndRosters = branch(
  ({ programScope }: ProgramScope) => programScope.isProgramScope,
  withProgramsAndRostersByPrograms,
  withProgramsAndRostersByOrganization
);
